import React, { useEffect, useState } from "react";
import { Logo } from "@/components/Logo";
import { api } from "@/lib/api";
import { COMPANY, LEGAL_LAST_UPDATED } from "@/content/legal";

export default function RefundPolicy() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    api.get("/config").then(({ data }) => setConfig(data)).catch(() => {});
  }, []);

  const tiers = [...(config?.refund_tiers || [])].sort((a, b) => b.hours_before - a.hours_before);

  return (
    <div className="min-h-screen bg-black text-white">
      <nav className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-obsidian/70 border-b border-white/10">
        <div className="container mx-auto h-16 flex items-center justify-between px-4">
          <Logo />
        </div>
      </nav>

      <section className="relative pt-32 pb-24 lg:pt-40 lg:pb-32">
        <div className="relative z-10 max-w-3xl mx-auto px-6">
          <h1 className="text-4xl font-bold mb-8 text-center">Refund & Cancellation Policy</h1>

          <div className="space-y-8 text-gray-300 leading-7">
            {config ? (
              <section className="whitespace-pre-wrap">{config.refund_policy_content}</section>
            ) : (
              <div className="h-24 animate-pulse bg-white/5 rounded-xl" />
            )}

            {tiers.length > 0 && (
              <section>
                <h2 className="text-2xl font-semibold mb-4">Refund Tiers</h2>
                <div className="bg-zinc-900 rounded-xl overflow-hidden">
                  <table className="w-full text-sm">
                    <thead className="border-b border-white/10">
                      <tr className="text-left text-gray-400 uppercase text-xs tracking-wider">
                        <th className="px-5 py-3">Notice given before slot</th>
                        <th className="px-5 py-3">Refund</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tiers.map((t, i) => (
                        <tr key={i} className="border-b border-white/5 last:border-0">
                          <td className="px-5 py-3">
                            {t.hours_before === 0 ? "Less than the next tier" : `${t.hours_before}+ hours`}
                          </td>
                          <td className="px-5 py-3 font-semibold text-volt">{t.refund_percent}%</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <p className="mt-4 text-sm text-gray-400">
                  Refunds are issued to the original payment method via Razorpay, typically within 5-7 business days.
                </p>
              </section>
            )}

            <section className="bg-zinc-900 rounded-xl p-6">
              <p className="font-semibold text-white">{COMPANY.name}</p>
              <p className="mt-1 text-sm text-gray-400">Owner and operator of {COMPANY.product}</p>
              <p className="mt-3">
                Questions about a refund? Email{" "}
                <a href={`mailto:${COMPANY.email}`} className="text-volt hover:underline">{COMPANY.email}</a>
              </p>
              <p className="mt-4 text-sm text-gray-400">Last Updated: {LEGAL_LAST_UPDATED}</p>
            </section>
          </div>
        </div>
      </section>
    </div>
  );
}
